export default "__VITE_ASSET__CbdBZVaf__"